/**
 * KRA Photo Journal – StatusBadge
 * Small inline badge showing Preview Sync status.
 */

import React from "react";
import type { PreviewSyncStatus } from "@kra/photo-journal-shared";
import { cn } from "../lib/utils.js";

const STATUS_CONFIG: Record<
  PreviewSyncStatus,
  { label: string; className: string }
> = {
  Ready: { label: "Ready", className: "text-status-ready bg-green-50" },
  Queued: { label: "Queued", className: "text-status-queued bg-amber-50" },
  Processing: { label: "Syncing…", className: "text-status-processing bg-blue-50" },
  Failed: { label: "Failed", className: "text-status-failed bg-red-50" },
  Refresh: { label: "Refresh", className: "text-status-queued bg-amber-50" },
  "Not synced": { label: "No preview", className: "text-ink-3 bg-surface-2" },
};

interface StatusBadgeProps {
  status: PreviewSyncStatus;
  className?: string;
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG["Not synced"];
  return (
    <span
      className={cn(
        "inline-flex items-center px-1.5 py-0.5 rounded text-2xs font-medium",
        config.className,
        className
      )}
    >
      {config.label}
    </span>
  );
}
